export default __webpack_public_path__ + "static/media/bQ.8df819f8.svg";